export const CALCULATE_PROFIT_SUBMIT = 'CALCULATE_PROFIT_SUBMIT';
export const CALCULATE_PROFIT_SUCCESS = 'CALCULATE_PROFIT_SUCCESS';
export const CALCULATE_PROFIT_ERROR = 'CALCULATE_PROFIT_ERROR';

export const SEND_CONTACT_LEAD_SUBMIT = 'SEND_CONTACT_LEAD_SUBMIT';
export const SEND_CONTACT_LEAD_SUCCESS = 'SEND_CONTACT_LEAD_SUCCESS';
export const SEND_CONTACT_LEAD_ERROR = 'SEND_CONTACT_LEAD_ERROR';
